// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"661":"af271fb2","678":"f93f7a1d","930":"191af377"}[chunkId] + ".chunk.css";
};